

























































import { defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';
import { publish } from '../../../../shared/eventbus/eventbus';
import { Events } from '../../../../shared/eventbus/events';
import { useRouter } from '../../../composables/use-router';
import { useI18N } from '../../../composables/use-vue-i18n';
import { useLabelTranslation } from './SideNavigationUtils';
import { SideNavigationGroupItem, UISideNavigationItem } from './types';

export default defineComponent({
  props: {
    navGroupItem: {
      type: Object as PropType<SideNavigationGroupItem>,
      required: true,
    },
    hideGroupLabel: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const i18n = useI18N();
    const router = useRouter();

    const containingPathNavItems = props.navGroupItem.items.filter(
      (navItem) => router.route.value.path.endsWith(navItem.data.url),
    );
    if (containingPathNavItems.length > 0) {
      const exactMatchNavItem = containingPathNavItems.find(
        (navItem) => navItem.data.url === router.route.value.path,
      );
      if (exactMatchNavItem != null) {
        (exactMatchNavItem as UISideNavigationItem).isActive = true;
      } else {
        (containingPathNavItems[0] as UISideNavigationItem).isActive = true;
      }
    }

    const openModal = () => {
      publish(Events.OpenRechargeModal, {});
    };

    const translateLabel = useLabelTranslation(i18n);

    return {
      i18n,
      openModal,
      translateLabel,
      navItems: props.navGroupItem.items as Array<UISideNavigationItem>,
    };
  },
});
